import { render, staticRenderFns } from "./loginLayout.vue?vue&type=template&id=3029b30e&scoped=true&"
import script from "./loginLayout.vue?vue&type=script&lang=js&"
export * from "./loginLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3029b30e",
  null
  
)

export default component.exports